<section class="col-12 faq-toggles-home mt-5 justify-content-center mb-5">
    <div class="titles ">
  <h2 class="text-center mb-4">{{titulo}}</h2>
  <p>{{subtitulo}}</p>
  </div>
<div class="container my-4">
  <div id="faqAccordion">
    <div *ngFor="let item of faqItems; let i = index" class="card toggle-faq">
      <div class="card-header" 
      [ngClass]="{ 'open-header': isOpen(i), 'closed-header': !isOpen(i) }"
      (click)="toggle(i)">
        <div class="d-flex justify-content-between align-items-center">
          <span class="faq-title">{{ item.pregunta }}</span>
          <i class="fas fa-chevron-down arrow-icon" [class.rotate]="isOpen(i)"></i>
        </div>
      </div>

      <div [@collapseAnim]="isOpen(i) ? 'open' : 'closed'" class="animated-collapse">
        <div class="card-body" [innerHTML]="item.respuesta"></div>
      </div>
    </div>
  </div>
</div>
</section>